<template>
  <div>
    <label>
      CONTAMINANT EMISSIONS: (please check all applicable contaminants)
    </label>
    <div class="row w-100">
      <div class="col-3 t-50">
        <base-checkbox v-model="form.particulateMatterInd"
                       label="Particulate Matter" />
      </div>
      <div class="col-3">
        <base-input v-model="form.particulateMatterBS"
                    label="BS"
                    typeof="number"
                    min="0"
                    placeholder="BS"
                    :readonly="form.particulateMatterInd == false"
                    :validation="val.form.particulateMatterBS" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col-3 t-50">
        <base-checkbox v-model="form.sulfurDioxideInd"
                       label="Sulfer Dioxide" />
      </div>
      <div class="col-3">
        <base-input v-model="form.sulfurDioxideBS"
                    label="BS"
                    typeof="number"
                    min="0"
                    placeholder="BS"
                    :readonly="form.sulfurDioxideInd == false"
                    :validation="val.form.sulfurDioxideBS" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col-3 t-50">
        <base-checkbox v-model="form.nitrogenOxideInd"
                       label="Nitrogen Oxide" />
      </div>
      <div class="col-3">
        <base-input v-model="form.nitrogenOxideBS"
                    label="BS"
                    typeof="number"
                    min="0"
                    placeholder="BS"
                    :readonly="form.nitrogenOxideInd == false"
                    :validation="val.form.nitrogenOxideBS" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col-3 t-50">
        <base-checkbox v-model="form.organicMaterialInd"
                       label="Oraganic Material" />
      </div>
      <div class="col-3">
        <base-input v-model="form.organicMaterialBS"
                    label="BS"
                    typeof="number"
                    min="0"
                    placeholder="BS"
                    :readonly="form.organicMaterialInd == false"
                    :validation="val.form.organicMaterialBS" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col-3 t-50">
        <base-checkbox v-model="form.carbonMonoxideInd"
                       label="Carbon Monoxide" />
      </div>
      <div class="col-3">
        <base-input v-model="form.carbonMonoxideBS"
                    label="BS"
                    typeof="number"
                    min="0"
                    placeholder="BS"
                    :readonly="form.carbonMonoxideInd == false"
                    :validation="val.form.carbonMonoxideBS" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col-3 t-50">
        <base-checkbox v-model="form.otherInd"
                       label="Other" />
      </div>
      <div class="col-3">
        <base-input v-model="form.otherDsc"
                    label="Please detail"
                    placeholder="Detail"
                    :readonly="form.otherInd == false"
                    :validation="val.form.otherDsc" />
      </div>
      <div class="col-3">
        <base-input v-model="form.otherBS"
                    label="BS"
                    typeof="number"
                    min="0"
                    placeholder="BS"
                    :readonly="form.otherInd == false"
                    :validation="val.form.otherBS" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.disposalMethod"
                    label="Method to be used to dispose of the residue from open burning"
                    placeholder="Disposal Method"
                    :validation="val.form.disposalMethod" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p class="font-14">Steps taken in planning for open burning to minimize emissions and air quality impacts:</p>
      </div>
    </div>
    <div class="row w-100">
      <div class="col-3">
        <base-checkbox v-model="form.abatementAmountOfMaterial"
                       label="Amount of Material" />
      </div>
      <div class="col-3">
        <base-checkbox v-model="form.abatementScheduling"
                       label="Scheduling" />
      </div>
      <div class="col-3">
        <base-checkbox v-model="form.abatementSiteSelection"
                       label="Site Selection" />
      </div>
      <div class="col-3">
        <base-checkbox v-model="form.abatementStepstOther"
                       label="Other" />
      </div>
    </div>
    <div class="row w-100" v-if="form.abatementStepstOther">
      <div class="col">
        <base-input v-model="form.abatementOtherDesc"
                    label="Explaination"
                    placeholder="Explaination"
                    :validation="val.form.abatementOtherDesc" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <p class="font-14">Methods used during open burning to reduce contaminant emissions and minimize impact on air quality:</p>
      </div>
    </div>
    <div class="row w-100">
      <div class="col-3">
        <base-checkbox v-model="form.abatementWaterFog"
                       label="Water / Fog Curtain" />
      </div>
      <div class="col-3">
        <base-checkbox v-model="form.abatementControlledBurn"
                       label="Controlled Burn" />
      </div>
      <div class="col-3">
        <base-checkbox v-model="form.abatementMethodsOther"
                       label="Other" />
      </div>
    </div>
    <div class="row w-100" v-if="form.abatementMethodsOther">
      <div class="col">
        <base-input v-model="form.abatementMethodsDesc"
                    label="Explaination"
                    placeholder="Explaination"
                    :validation="val.form.abatementMethodsDesc" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <yes-no v-model="form.individualsNotifiedInd"
                label="Have individuals living or working near the site been notified of the proposed open burning?" />
      </div>
    </div>
    <div class="row w-100" v-if="form.individualsNotifiedInd">
      <div class="col">
        <base-input v-model="form.individualsNotifiedExplaination"
                    label="Explain method of notice and any additional measures to be taken to respond to concern"
                    placeholder="Explanation"
                    :validation="val.form.individualsNotifiedExplaination" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <yes-no v-model="form.isBurn100FeetAwayInd"
                label="Is burn 1000 feet from residence and businesses?" />
      </div>
    </div>
    <div class="w-100" v-if="form.typeOfRequest == 'Prarie or Ecology Management'">
      <div class="row w-100">
        <div class="col">
          <p style="text-decoration: underline;"> Addition Prarie or Ecology Management Information </p>
        </div>
      </div>
      <div class="row w-100">
        <div class="col">
          <base-input v-model="form.nameOfDevice"
                      label="Name of air curtain destructor or comparable device"
                      placeholder="Name"
                      :validation="val.form.nameOfDevice" />
        </div>
      </div>
      <div class="row w-100">
        <div class="col">
          <base-input v-model="form.manufacturer"
                      label="Manufacturer"
                      placeholder="Manufacturer"
                      :validation="val.form.manufacturer" />
        </div>
        <div class="col">
          <base-input v-model="form.modelNo"
                      label="Model No"
                      placeholder="Model No"
                      :validation="val.form.modelNo" />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p class="font-14">Attach a copy of the manufacturer’s written instructions for use of the device to the application.  A copy of these instructions should be available at time of open burning at site. </p>
        </div>
        <div class="col-12">
          <base-file-uploader v-model="form.files.writtenInstructions"
                              label="Written Instruction"
                              :validation="val.form.files.writtenInstructions"
                              :file="form.existingFileDetails.writtenInstructions" />
        </div>
      </div>
    </div>

    <div class="w-100" v-if="form.typeOfRequest == 'Disaster Waste'">
      <div class="row w-100">
        <div class="col">
          <p style="text-decoration: underline;"> Addition Disaster Waste Information </p>
        </div>
      </div>
      <div class="row w-100">
        <div class="col">
          <base-select v-model="form.typeOfDisaster"
                       :options="form.typeOfDisasterOptions"
                       :validation="val.form.typeOfDisaster"
                       label="Type of Disaster">
          </base-select>
        </div>
        <div class="col">
          <base-select v-model="form.disasterDeclaredBy"
                       :options="form.disasterDeclaredByOptions"
                       :validation="val.form.disasterDeclaredBy"
                       label="Disaster Declared By">
          </base-select>
        </div>
      </div>
      <div class="row w-100">
        <div class="col">
          <yes-no v-model="form.disasterMaterialsBurnedInd"
                  label="Will material other than clean wooden burning debris, landscape waste or agricultural waste, caused by the disaster, be burned?" />
        </div>
      </div>
    </div>

    <div class="w-100" v-if="form.typeOfRequest == 'Firefighting Instruction / Research'">
      <div class="row w-100">
        <div class="col">
          <p style="text-decoration: underline;"> Addition Firefighting Instruction / Research Information </p>
        </div>
      </div>
      <div class="row w-75">
        <div class="b-bottom w-100" v-for="(item, index) in form.additionalInformationFirefighters">
          <div class="col">
            <base-input v-model="item.partInExcersice"
                        label="Participation in the exercise"
                        placeholder="Participation in the Exercise" />
          </div>
          <div class="col">
            <base-input v-model="item.organization"
                        label="Organization of Departments"
                        placeholder="Organization of Departments" />
          </div>
          <div class="col">
            <base-input v-model="item.numParticipants"
                        label="Number of Participants"
                        type="number"
                        min="0"
                        placeholder="Number of Participants" />
          </div>
          <div class="col">
            <button v-if="index > 0" class="btn btn-danger" style="margin-bottom: 2%;"
                    @click="removeInfo(index)">
              Remove
            </button>
          </div>
        </div>
      </div>
      <div class="row w-100">
        <div class="col">
          <button style="margin-bottom: 2%;" class="btn btn-primary"
                  @click="addInfo">
            Add More Information
          </button>
        </div>
      </div>
      <div class="row w-100">
        <div class="col">
          <label>Scope of Training Exercises:</label>
        </div>
      </div>
      <div class="row w-100">
        <div class="col-4">
          <base-checkbox v-model="form.useOfExtinguishersInd"
                         label="Use of Extinguishers" />
        </div>
        <div class="col-4">
          <base-checkbox v-model="form.forcibleEntryInd"
                         label="Forcible Entry" />
        </div>
        <div class="col-4">
          <base-checkbox v-model="form.rescueTechnicianInd"
                         label="Rescue Technician" />
        </div>
      </div>
      <div class="row w-100">
        <div class="col-6">
          <base-checkbox v-model="form.useOfMasksAndBreathingApparatusInd"
                         label="Use of Smoke Masks and Breathing Apparatus " />
        </div>
        <div class="col-6">
          <base-checkbox v-model="form.ffTrainingOtherInd"
                         label="Other" />
        </div>
      </div>
      <div class="row w-100" v-if="form.ffTrainingOtherInd">
        <div class="col-12">
          <base-input v-model="form.ffTrainingOtherDesc"
                      label="Other Description"
                      placeholder="Other Description"
                      :validation="val.form.ffTrainingOtherDesc" />
        </div>
      </div>
      <div class="row w-100">
        <div class="col">
          <base-input v-model="form.ffDescRelatedToExersise"
                      label="Description of open burning as related to the training exercise (plan of fire, phases of training, methods of ignition, extinguishment methods, etc.)"
                      placeholder="Description of open burning as related to the training exercise"
                      :validation="val.form.ffDescRelatedToExersise" />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p class="font-14">Attach a <strong style="text-decoration: underline; font-weight: bold;">written plan</strong> for exercise or similar exercise, if available. </p>
        </div>
        <div class="col-12">
          <base-file-uploader v-model="form.files.ffWrittenPlan"
                              label="Written Plan"
                              :file="form.existingFileDetails.ffWrittenPlan" />
        </div>
      </div>
      <div class="row w-100">
        <div class="col">
          <base-input v-model="form.ffListOfTrainingActivitiesLastYear"
                      label="List of other training activities in the last 12 months including all open burning exercises"
                      placeholder="List of other training activies" />
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VAddress from '~/components/VAddress';
import BaseCheckbox from '~/components/BaseCheckbox';
import BaseInput from '~/components/BaseInput';
import YesNo from '~/components/YesNo';
import BaseSelect from '~/components/BaseSelect';
import BaseFileUploader from '~/components/BaseFileUploader';

export default {
  name: 'AdditionalInfo',
  props: ['form', 'val'],
  components: {
    VAddress, BaseCheckbox, BaseInput, YesNo, BaseSelect, BaseFileUploader,
  },
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {
    addInfo() {
      this.$props.form.additionalInformationFirefighters.push({ partInExcersice: null, organization: null, numParticipants: null });
    },
    removeInfo(index) {
      this.$props.form.additionalInformationFirefighters.splice(index, 1);
    },
  },
};

</script>
